import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type NoteProps = {
    className?: string;
};

const Note: FunctionComponent<NoteProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'note'}
            viewBox="0 0 100 100"
        >
            <path d="M86.426 77.98c.42.007.795.322.954.801.16.48.073 1.03-.22 1.4L73.975 96.49c-.3.373-.753.486-1.146.284-.393-.202-.649-.678-.646-1.204V81.865c0-2.146 1.407-3.886 3.144-3.886h11.099zM85.808 0C88.123 0 90 2.32 90 5.181v62.436c0 1.43-.938 2.59-2.096 2.59H75.327c-5.21 0-9.433 5.22-9.433 11.658V97.41c0 1.431-.938 2.591-2.096 2.591H14.192C11.877 100 10 97.68 10 94.819V5.18C10 2.32 11.877 0 14.192 0h71.616zM18.175 8.42v83.16h39.544v-9.715c0-10.783 7.52-20.077 17.608-20.077h6.498V8.42h-63.65zm55.359 18.147H25.222c-1.623 0-2.938-1.74-2.938-3.886s1.315-3.886 2.938-3.886h48.312c1.622 0 2.938 1.74 2.938 3.886 0 2.147-1.316 3.886-2.938 3.886zm0 18.588H25.222c-1.623 0-2.938-1.74-2.938-3.886s1.315-3.886 2.938-3.886h48.312c1.622 0 2.938 1.74 2.938 3.886 0 2.147-1.316 3.886-2.938 3.886zM53.946 62.5H25.222c-1.623 0-2.938-1.74-2.938-3.886s1.315-3.886 2.938-3.886h28.724c1.623 0 2.939 1.74 2.939 3.886S55.569 62.5 53.946 62.5z" />
        </svg>
    );
};
export default Note;
